import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";

export default {
    query(query) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/selectPage',
            method: 'post',
            params: query
        });
    },

    insert(f) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/insert',
            method: 'post',
            data: f
        });
    },
    chongx(f) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/claimChongx',
            method: 'post',
            data: f
        });
    },
    toDel(f) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/deleteById',
            method: 'post',
            data: f
        });
    },
    conditionalSearch(q) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/conditionalSearch',
            method: 'post',
            params: q
        });
    },
    conditionalSearchSum(q) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/conditionalSearchSum',
            method: 'post',
            params: q
        });
    },
    conditionalUserSearch(q) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/conditionalUserSearch',
            method: 'post',
            params: q
        });
    },
    insertRough(f) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/insertRough',
            method: 'post',
            header: 'application/x-www-form-urlencoded;charset=UTF-8',
            data: f
        });
    },
    queryOne(id) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/selectById',
            method: 'post',
            params: {id}
        });
    },
    download(c) {
        updownfile.down('/api/swyl/v1/foreign/userReceForeign/downloadExcel', c, "post", "data");
    },
    queryForeign(id) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/selectById',
            method: 'post',
            params: {id}
        });
    },
    claimApprove(v) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/claimApprove',
            method: 'post',
            data: v
        });
    },
}
